import React, { Component } from "react"
import PropTypes from "prop-types"
import ProfileAboutMessage from "profiles/components/ProfileAboutMessage"
import "app/static/stylus/TextWithTabs.styl"
import styled from "styled-components"

import { TextSection } from "quorumdesign"

const StyledContent = styled.div`
    img {
        max-width: 100%;
        height: auto;
    }
`

export default class TextWithTabs extends Component {
    onTabClick = (e) => this.props.setCurrentTab(this.props.profileId, e.target.innerHTML)

    getToggles = () => this.props.data.map((dataObj) => ({ name: dataObj.title }))

    getMessageText = () =>
        this.props.data.find((dataObj) => dataObj.title === (this.props.currentTab || this.props.data[0].title))
            .subtitle

    render() {
        return !(this.props.textSections && this.props.textSections.length > 1) && this.props.isPDF ? (
            <ProfileAboutMessage
                isPDF={this.props.isPDF}
                messageText={this.getMessageText()}
                displayFullPDFHeight={this.props.displayFullPDFHeight}
                languageUrls={this.props.languageUrls}
                isMultiLanguagePDF={this.props.isMultiLanguagePDF}
                hasDiscreteSelect={this.props.hasDiscreteSelect}
                discreteSelectOptions={this.props.discreteSelectOptions}
                getDefault={this.props.getDefault}
                formatOptions={this.props.formatOptions}
                getUrl={this.props.getUrl}
            />
        ) : (
            <StyledContent>
                <TextSection
                    forceExpanded={this.props.displayFullPDFHeight}
                    headerText={this.props.title}
                    textSections={this.props.textSections.map((section) => ({
                        ...section,
                        // We need to call the setCurrentTab action creator from the DS TextSection
                        // in order to keep the selectors up to date for the PDF viewer
                        sectionOnClick: () => this.props.setCurrentTab(this.props.profileId, section.sectionLabel),
                        text: this.props.isPDF ? (
                            // We need to get a PDF viewer if the "current tab" (according to the selectors)
                            // is a PDF tab; we can pass this component to the DS TextSection to be rendered
                            // as a child as long as the selectors are up to date
                            <ProfileAboutMessage
                                isPDF={this.props.isPDF}
                                messageText={this.getMessageText()}
                                displayFullPDFHeight={true}
                                languageUrls={this.props.languageUrls}
                                isMultiLanguagePDF={this.props.isMultiLanguagePDF}
                                hasDiscreteSelect={this.props.hasDiscreteSelect}
                                discreteSelectOptions={this.props.discreteSelectOptions}
                                getDefault={this.props.getDefault}
                                formatOptions={this.props.formatOptions}
                                getUrl={this.props.getUrl}
                            />
                        ) : (
                            // if we don't need a PDF viewew, pass along the section object's text prop
                            section.text
                        ),
                    }))}
                />
            </StyledContent>
        )
    }
}

TextWithTabs.propTypes = {
    data: PropTypes.array,
    currentTab: PropTypes.string,
    title: PropTypes.string,
    profileId: PropTypes.number,
    setCurrentTab: PropTypes.func,
    isPDF: PropTypes.bool,
    displayFullPDFHeight: PropTypes.bool,
    languageUrls: PropTypes.array,
    isMultiLanguagePDF: PropTypes.bool,
    hasDiscreteSelect: PropTypes.bool,
    discreteSelectOptions: PropTypes.array,
    getDefault: PropTypes.func,
    formatOptions: PropTypes.func,
    getUrl: PropTypes.func,
    textSections: PropTypes.array,
}
